export enum TransitionTarget {
    PurchaseOrder = 1,
    Invoice = 2,
    Inquiry = 3,
    Credit = 4,
}
